const getCookie = name => {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  const arr = document.cookie.match(reg)
  return arr ? arr[2] : null
}

const setCookie = (key, value) => {
  document.cookie = key + '=' + value
}

export { getCookie, setCookie }



// WEBPACK FOOTER //
// ./src/tools/cookie.js